import mixpanel from "mixpanel-browser";
import { useCallback } from "react";

/**
 * Hook for sending Mixpanel events to the Promotion project only.
 * This is completely separate from the main Mixpanel instance.
 * No user identification needed as this is for anonymous onboarding tracking.
 */
export default function useMixpanelPromotion(request: {
  params?: { [key: string]: string };
  eventName: string;
}) {
  const params = request.params ? request.params : {};

  const fetchData = useCallback(async () => {
    try {
      const promotionInstance = (mixpanel as any).promotion;
      if (promotionInstance) {
        promotionInstance.track(request.eventName, params);
      } else {
        console.warn("Mixpanel promotion instance not initialized");
      }
    } catch (error) {
      console.error("error", error);
    }
  }, [request.eventName, params]);

  return fetchData;
}
